import DataTable from 'react-data-table-component';
import React from 'react'
import Actionall from './actionall';
import Statusall from './statusallByuser';
import { FaFileSignature, FaCheckCircle } from "react-icons/fa";
import Flowuserapprove from '../componentallstatus/flowuserapprove';

const columns = [
    {
        name: 'TDS code',
        sortable: true,
         grow: 1,
        selector: row =>row.tdscode,
    },
    {
        name: 'V',
         sortable: true,
          grow: 0.5,
        selector: row => row.revision,
    },
    {
        name: 'customer / product',
        grow: 2,
        selector: row =><div>
            <div>: {row.fname}</div>
           <div>: {row.customername}</div> 
           <div>: {row.productname}</div>
            </div>,
    },
    {
        name: 'cansize',
        selector: row => row.cansize,
        grow: 1,
    },
    {
        name: 'status all',
        selector: row =>
            <Statusall id={row.journalId} statusflownow={row.statusflow}
                stateflow={row.stateflow} stateSuccesfull={row.stateSuccesfull} />,
        grow: 1,
    },
    {
        name: 'รออนุมัติ',
        grow: 1.5,
        selector: row => row.flowSuccesfull != "1" ? <Flowuserapprove 
        id={row.journalId} 
        stateflow={row.stateflow} 
        departments={row.departments}
        accountapprove={row.accountapprove}
        /> :"",
    },
    {
        name: 'confirm job',
         grow: 1,
        selector: row => <div>
            <div>{row.statusConfirm == '1' ? <label style={{ color: 'green' }}><FaCheckCircle /> Approve </label> : <label></label>}</div>
        </div>,
    },
    {
        name: 'createdate',
        sortable: true,
        grow: 1,
        selector: row => row.createdate,
    },
    {
        name: 'Action',
        grow: 1,
        cell: row => <Actionall id={row.journalId} journalcode={row.tdscode}
            stateflow={row.stateflow}
            stateSuccesfull={row.stateSuccesfull}
            revision={row.revision}
        />,
    },

];

const customStyles = {
    headRow: {
        style: {
            border: 'none',
            backgroundColor: '#28B463'
        },
    },
    headCells: {
        style: {
            color: '#ffff',
            fontSize: '14px',
        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgb(230, 244, 244)',
            borderBottomColor: '#FFFFFF',
            borderRadius: '25px',
            outline: '1px solid #FFFFFF',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
};



const Jornallistbyuser = (datatable) => {
    var dataresult = datatable.datatable;
    // console.log(dataresult)

    return (

        <DataTable
            columns={columns}
            data={dataresult}
            // selectableRows
            pagination
            customStyles={customStyles}
            highlightOnHover

        />
    )
}

export default Jornallistbyuser